interface Props {
  value: string
}

const badgeClass: { [key: string]: string } = {
  customer: 'badge-warning',
  vendor: 'badge-primary',
  employee: 'badge-light',
}

const ResourceBadge: React.FC<Props> = ({ value }) => {
  return (
    <div className={`badge ${badgeClass[value.toLowerCase()]}`}>
      {value.substring(0, 1).toUpperCase() + value.substring(1).toLowerCase()}
    </div>
  )
}

export default ResourceBadge
